import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import Accordion from 'components/Accordion';
import BonusCard, { ILockedBonusCard, IReadyBonusCard } from 'components/BonusCard';
import RestrictedContainer from 'components/RestrictedContainer';

import './BonusView.scss';

export interface IBonusViewProps {
  readyCards: IReadyBonusCard[];
  lockedCards: ILockedBonusCard[];
}

const BonusView = (props: IBonusViewProps) => {
  const { t } = useTranslation();

  const cardCategories: React.ReactElement[] = [];
  if (props.readyCards.length) {
    cardCategories.push(
      <Accordion
        key="cards-ready"
        title={t('ready-to-use')}
        showCount={true}
        children={props.readyCards.map((data) => (
          <BonusCard key={data.identifier} {...data} />
        ))}
      />
    );
  }
  if (props.lockedCards.length) {
    cardCategories.push(
      <Accordion
        key="cards-locked"
        title={t('locked')}
        showCount={true}
        children={props.lockedCards.map((data) => (
          <BonusCard key={data.identifier} {...data} />
        ))}
      />
    );
  }

  return (
    <RestrictedContainer className="bonus">
      <p className="bonus__description">{t('bonus-cards-help-boost-your-chances')}</p>
      {cardCategories.map((element, index) => (
        <Fragment key={element.key || index}>
          {index > 0 && <div className="bonus__separator" />}
          <div className="bonus__cards">{element}</div>
        </Fragment>
      ))}
    </RestrictedContainer>
  );
};

export default BonusView;
